var widget_default = {
  "card": "jLalu",
  "link": "dgxXD",
  "container": "_0FPmD",
  "image": "DngvP",
  "right": "XYcRy",
  "cardLayout": "_9dPFd",
  "content": "gU1P-",
  "title": "vdVdg",
  "subtitle": "G6Mbh",
  "button": "_5GO-A",
  "button_disabled": "ZSAud",
  "buttonText": "uBrOi",
  "slimLayout": "GPv4-",
  "contentText": "LOfpk"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
